<template>
  <div :class="['search-input-select', disabled ? 'search-input-select_disabled' : '']">
    <VCustomInput
    :disabled="disabled || loading"
    :placeholder="placeholder"
    :error="errorSearch"
    v-model="inputVal"
    id="region" btn-clear
    @input="onInput"
    @focus="showItems = true"
    @blur="blur"
    class="search-input-select__inp"
  />
    <p class="search-input-select__inp-error" v-if="error">{{ errorMessage }}</p>
    <p class="search-input-select__inp-error" v-if="!error && errorSearch">Такого города нет в базе</p>

    <div
      class="search-input-select__section-search-items"
      v-if="showItems && resultsResidence.length"
    >
      <div
        class="search-input-select__section-search-result"
        v-for="item in resultsResidence"
        :key="item.id"
        :class="{
          'search-input-select__section-search-result_active':
            false === item.id,
          'search-input-select__sub-title': item.subTitle,
          'search-input-select__disable-item': item?.disable,

        }"
        @click="selectItem(item, item?.disable)"
      >
        {{ item.name?.replace(/\s*\([^)]*\)\s*/, ' ')?.trim() }}
        <div class="search-input-select__sub-title-text">{{ item.subTitle }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import common from "@/api/common";
import {debounce} from "@/services/helpers";

const props = defineProps({
  modelValue: [String, Number],
  placeholder: {
    type: String,
  },
  error: {
    type: Boolean,
    default: false,
  },
  errorMessage: {
    type: String,
  },
  disabled: {
    type: Boolean,
    default: false
  },
  loading: Boolean
});

const resultsResidence = ref([])

const emit = defineEmits(["update:modelValue", "blur", "selectItem", "input"]);
const inputVal = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const showItems = ref(false);
const errorRes = ref(false);

const errorSearch = computed(() => {
  if(props.error) return true;
  if(!props.loading && errorRes.value && props.modelValue) return true;
  if(!props.loading && resultsResidence.value === false) return true;
})

const itemsList = computed(() => {
  return props.items.filter(
    (item) =>
      item
        ?.toUpperCase().indexOf(inputVal.value ? inputVal.value.toUpperCase() : "") >= 0
  );
});

const searchResidence = async () => {
  errorRes.value = false;
  const res = await common.searchResidence(props.modelValue);
  if (res?.data) {
    resultsResidence.value = res?.data.map((item) => {
      return {
        ...item,
        name: item?.fullDescription? item?.fullDescription: item?.name,
      };
    });
    errorRes.value = res?.data?.length === 0;
    if(props.modelValue?.length < 1) {
      errorRes.value = false;
    }
  }
};

const debouncedSearchResidence = debounce(() => searchResidence(), 400);

const onInput = (val) => {
  debouncedSearchResidence()
  emit("input", val)
}

const selectItem = (item, disable) => {
  if(disable) return
  emit("selectItem", item)
}
const blur = () => {
  setTimeout(() => {
    showItems.value = false;
  }, 300);
  setTimeout(() => {
    emit("blur");
  }, 400);
};
</script>

<style scoped lang="scss">
.search-input-select {
  position: relative;

  &_disabled {
    cursor: default;
    user-select: none;
    pointer-events: none;
    opacity: 0.5;
  }

  &__inp {
    width: 100%;
    :deep(.v-input__input){
      overflow-x: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  &__items {
    position: absolute;
    top: 56px;
    left: 0;
    width: 100%;
    max-height: 300px;
    padding: 8px;
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid $light-gray-1;
    box-shadow: 2px 4px 24px 0px rgba(0, 0, 0, 0.12);
    z-index: 2;
    overflow-y: auto;
    
    &::-webkit-scrollbar {
      width: 0;
    }
  }

  &__item {
    width: 100%;
    height: 40px;
    padding-left: 8px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    user-select: none;
    transition: 0.1s;

    &:hover {
      background-color: $light-gray-1;
    }
  }

  &__inp-error {
    margin-top: 4px;
    font-size: 14px;
    color: $red;
  }

  &__section-search-items {
    position: absolute;
    top: 56px;
    left: 0;
    width: 100%;
    padding: 8px;
    border-radius: 8px;
    background-color: #fff;
    border: 1px solid $light-gray-1;
    box-shadow: 2px 4px 24px 0 #0000001f;
    z-index: 9;
    overflow-y: auto;
    scrollbar-width: thin;
    max-height: calc(45px * 5);
  }

  &__section-search-result {
    width: 100%;
    height: 40px;
    border-radius: 8px;
    padding: 12px 8px 4px;
    display: block;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:hover {
      background-color: $light-gray-1;
      color: $dark;
    }
  }

  &__sub-title {
    height: auto;
  }
  //
  //&__sub-title-text {
  //  font-size: 12px;
  //  color: $grey-pressed;
  //  margin-top: 2px;
  //  display: flex;
  //  display: -webkit-box;
  //  -webkit-box-orient: vertical;
  //  -webkit-line-clamp: 2;
  //  overflow: hidden;
  //  text-overflow: ellipsis;
  //  white-space: normal;
  //}
  //
  //&__disable-item {
  //  color: $grey-pressed;
  //  opacity: 50%;
  //}
}
</style>
